<template>
  <!--
    Freeze / unfreeze / block through the concierge (docs/cabinet-redesign/02 §5.1 В-5): «Заморозка карты ··1234» with
    where the request is — «ждёт менеджера», then «выполнено» or «отклонено» with the manager's reason. Posted when the
    request is made and again when it is decided; each card reads the request as it is now.
  -->
  <div class="cb" data-testid="chat-block-CARD_ACTION" :data-stage="stage">
    <div class="cb__title" data-testid="card-action-title">{{ title }}</div>
    <p v-if="!r" class="cb__text">{{ t('cabinet.cardAction.gone') }}</p>
    <template v-else>
      <div class="cb__row">
        <small>{{ t('cabinet.topupChat.status') }}</small>
        <span class="ca-status" :class="`ca-status--${r.status.toLowerCase()}`" data-testid="card-action-status"
              :data-status="r.status">{{ t(`cabinet.cardAction.status.${r.status}`) }}</span>
      </div>
      <p v-if="stage === 'REQUESTED' && r.reason" class="cb__text">«{{ r.reason }}»</p>
      <p v-if="stage === 'DONE'" class="cb__hint" data-testid="card-action-done">{{ t(`cabinet.cardAction.done.${r.action}`) }}</p>
      <div v-if="stage === 'REJECTED' && r.rejectReason" class="cb__notice" data-testid="card-action-rejected">
        <div class="cb__noticeTitle">{{ t('cabinet.cardAction.rejectedTitle') }}</div>
        <div class="cb__noticeBody">{{ r.rejectReason }}</div>
      </div>
      <p v-if="stage === 'REQUESTED' && r.status === 'PENDING'" class="cb__hint">
        {{ t(r.action === 'ADD_TO_WALLET' ? 'cabinet.cardAction.note.ADD_TO_WALLET' : 'cabinet.card.blockNote') }}</p>
    </template>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import type { BlockState } from '@/api/support';

const props = defineProps<{
  stage: 'REQUESTED' | 'DONE' | 'REJECTED';
  state?: Extract<BlockState, { type: 'CARD_ACTION' }>;
}>();
const { t } = useI18n();

const r = computed(() => props.state?.request ?? null);
/** «Заморозка карты ··1234». */
const title = computed(() => {
  const action = r.value?.action ?? 'FREEZE';
  const last4 = r.value?.cardLastFour;
  return t(`cabinet.cardAction.title.${action}`, { last4: last4 ? ` ··${last4}` : '' });
});
</script>

<style scoped lang="scss">
@use './cards.scss';

.ca-status { font-weight: 500; }
.ca-status--pending { color: var(--bronze-text); }
.ca-status--done { color: var(--success-text); }
.ca-status--rejected { color: var(--muted); }
</style>
